export default __webpack_public_path__ + "static/media/4906.bdcee87b.png";